export const generateData = (data, columns) => data.map((rowData) => columns.map((columnDef) => rowData[columnDef.field]));
